import { Component, Input } from '@angular/core';
import {
  AnnualFrequencyEnum,
  LoanBankTypeEnum,
  LoanForm,
  LoanInterestTypeEnum,
  LoanRepaymentTypeEnum
} from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';

/**
 * Bank account loan form.
 * Allow user to add bank account's loan information.
 * Using in bank accounts add/import process.
 */
@Component({
  selector: 'app-bank-account-loan-form',
  templateUrl: './bank-account-loan-form.component.html',
  styleUrls: ['./bank-account-loan-form.component.scss'],
  standalone: false
})
export class BankAccountLoanFormComponent extends BaseComponent {
  @Input() form: LoanForm;
  loanTypes: typeof LoanBankTypeEnum = LoanBankTypeEnum;
  loanRepaymentFrequencies = AnnualFrequencyEnum;
  loanRepaymentTypes: typeof LoanRepaymentTypeEnum = LoanRepaymentTypeEnum;
  loanInterestTypes: typeof LoanInterestTypeEnum = LoanInterestTypeEnum;
}
